// src/config/routes.js
export const ROUTE_BASE = {
  CLIENT: '/client',
  ADMIN: '/admin',
};

export const ROUTES = {
  // Base paths
  CLIENT_BASE: ROUTE_BASE.CLIENT,
  ADMIN_BASE: ROUTE_BASE.ADMIN,

  // Client routes
  CLIENT_HOME: ROUTE_BASE.CLIENT,
  CLIENT_MENU: `${ROUTE_BASE.CLIENT}/menu`,
  CLIENT_DETAIL: `${ROUTE_BASE.CLIENT}/detail`,

  // Admin routes
  ADMIN_HOME: ROUTE_BASE.ADMIN,
  ADMIN_ADD_RECIPE: `${ROUTE_BASE.ADMIN}/addrecipe`,
  ADMIN_ADD_PRODUCT: `${ROUTE_BASE.ADMIN}/addproduct`,
  ADMIN_RECIPE_DETAIL: `${ROUTE_BASE.ADMIN}/recipedetail`,
  ADMIN_PRODUCT_DETAIL: `${ROUTE_BASE.ADMIN}/productdetail`,
  ADMIN_PRODUCT_EDIT: `${ROUTE_BASE.ADMIN}/productedit`,
  ADMIN_RECIPE_BOOK: `${ROUTE_BASE.ADMIN}/recipebook`,
};
